import React from 'react';
import Footer from '../components/Footer';
import Colors from '../Colors';
import NavBar from '../components/NavBar';

const questions = [
    {
        q: "Taşımacım'in çalışma saatleri nedir?",
        a: "Taşımacım, bir mobil uygulama kullanarak şimdilik İstanbul genelinde uygun ve esnek aynı gün teslimat hizmetleri sunmaktadır. Birkaç dakika içinde, uygulama sizi İstanbul ’daki binlerce motosikletçiye ve sürücüye bağlar."
    },
    {
        q: "Bir araç nasıl seçilir?",
        a: `-Motosiklet
        5 Kg'ın altında. 35 cm x 25 cm x 12 cm taşır.  
        Belgeler veya küçük bir paket (ayakkabı kutusu boyutu)
        -Doblo
        Maksimum ağırlık 200kg. Maksimum boyutlar: 1,8m x 1,5m x 1,2m
        Koliler, kutular, küçük mobilyalar, kısa bitkiler ve evcil hayvanlar için iyidir.
        -Minivan
        Maksimum ağırlık 500kg. Maksimum boyutlar: 2,1 m x 1.7 m x 1.2 m
        Tek kişilik yatak veya 2 kişilik kanepe için iyidir.
        -Panelvan
        Maksimum ağırlık 1000kg. Maksimum boyutlar: 3 m x 1,5 m x 1,5m
        3 kişilik kanepe veya yemek masası ve sandalyeler için iyidir.
        -Kamyonet
        Maksimum ağırlık 2500kg. Maksimum boyutlar: 4,2m x 2 m x 2 m
        Yatak odası takımı, ofis mobilyaları veya 1+1 ev taşımaları için iyidir.`
    },
    {
        t:"Taşımacım nasıl kullanılır",
        q:"Taşımacım'da nasıl rezervasyon yapabilirim?",
        a:`Rezervasyon yapmak için Android ve iOS'ta kullanılabilen mobil uygulamamızı indirin.
        Teslim alma ve bırakma konumunuzu, kişisel bilgilerinizi ve rezervasyon gereksinimlerinizin ayrıntılarını eklemeniz yeterlidir. Bir sürücü dakikalar içinde rezervasyonunuzla eşleştirilecek ve sizinle uygulama üzerinden iletişime geçecektir.`
    },
    {
        q:"Adresimi seçim listesinde bulamıyorum. Ne yapmalıyım?",
        a:`Sokak adınızı girdikten sonra tam adresiniz seçim listesinde görünmüyorsa, lütfen verilen alana tam adresinizi yazın.
        Motosiklet servisi, veya yardımcı gerektiren servislerden doblo, minivan,  panelvan yada kamyonet servisini seçtiyseniz, lütfen "Sipariş detayları" sayfasının altına, "Sürücüye not" alanına kat ve blok numaranızıda girin.`
    },
    {
        q:"Aylık olarak düzenli sayıda siparişim varsa, bana destek olmak için özel bir sürücü rezervasyonu yapabilir miyim?",
        a:`Evet. Taşımacım Esnaf programının bir parçası olarak, önemli bir hacim göz önüne alındığında, düzenli nakliye / teslimat ihtiyaçlarınızı karşılamak için seçtiğiniz sürücülerden oluşan bir grup sağlayabiliriz. İş eşleşmelerinde başarı, favori sürücülerinizin kullanılabilirliğine bağlıdır. 
        Taşımacım Esnaf  hakkında bilgi almak için lütfen telefon hattımızı arayın.`
    },
    {
        q:"Bazı durumlarda, sürücüye ödenen gerçek fiyat, uygulamada veya web sitesinde gösterilen fiyattan neden farklıdır?",
        a:`Siparişi incelerken uygulamada belirtilen fiyat, extra ücretleri ve her araç türü için öngörülen toplam hizmet süresinin ötesindeki ek süre ücretleri gibi diğer ücretleri içermez.
        Bir eve / ofise taşınırken sarma ve sökme hizmetleri gibi başka hizmetlere ihtiyacınız varsa, lütfen fiyat teklifini sürücüden isteyin ve yalnızca fiyatlandırmadan memnunsanız rezervasyonu kabul edin.`
    },
    {
        q:"Köprü ücretleri ve otopark ücretleri uygulamada belirtilen fiyata dahil mi?",
        a:`Evet, bu ücretler fiyat teklifinde belirtilmiştir.`
    },
    {
        q:"Rezervasyonum için sürücüyle eşleştirilmem ne kadar sürer?",
        a:`Taşımacım, platformumuzda kayıtlı olan serbest sürücülerden ve motosikletçilerden nakliye ve lojistik hizmetleri almanız için bir kanal sağlayan üçüncü taraf bir teknoloji platformudur. Bir sürücü ile eşleştirilmek için geçen süre bulunduğunuz yere, seçtiğiniz servise ve günün saatine bağlı olarak en kısa olacak şekilde belirlenir.`
    },
    {
        q:"Sürücü eşyalarımın taşınmasında yardımcı olacak mı?",
        a:`Motosiklet teslimatları için fiyata kapıdan kapıya teslimat dahildir.
        Araç hizmetleri için fiyata, sürücünün eşyalarınızı araca / araçtan yükleme ve boşaltma yardımı dahildir. Eşyaları dairenizin kapısına (çok katlı bina için) veya evinize getirmek için ek yardıma ihtiyacınız varsa, ek maliyetlerle birlikte gelen ihtiyaç duyulan insan gücünü belirtin.`
    },
    {
        q:"Bir sürücüyle eşleştirildim ve sürücünün bilgilerini de aldım. Şimdi ne yapmalıyım?",
        a:`Rezervasyonunuz eşleştirildikten sonra sürücünün bilgilerini aldıktan sonra, sürüş yapıyor olabileceğinden, sürücüye sizinle iletişime geçmesi için biraz zaman tanıyın. Sürücü eşleştirildikten sonraki 10 ~ 15 dakika içinde sizinle iletişime geçmezse, rezervasyonunuzun ayrıntılarını ve ek ücretleri (varsa) onaylamak için sürücüyle uygulama üzerinden bir arama başlatabilirsiniz.`,
    },
    {
        q: "Eşyalarımın ağırlığının ve boyutunun her araç için sınırları aşıp aşmadığından emin değilim.",
        a:`Taşımacım eşyalarınızın toplam ağırlığına ve boyutuna hitap eden farklı araç türleri sunar. Her aracın belirtilen ağırlık ve boyut sınırları için lütfen aşağıdaki sayfada her araç için verilen açıklamaya bakın: https://www.tasimacim.com/pricing
        Alternatif olarak, destek için bizi +90 850 270 07 23 numaralı telefondan arayabilirsiniz.`
    },
    {
        q: "Verilen listedeki eşyalarım için uygun bir araç bulamıyorum. Ne yapabilirim?",
        a:`Tüm öğelerinizi uygulamada ve web sitesinde gösterilen mevcut araç listesine sığdıramıyorsanız, öğelerin hacmini ayrı rezervasyonlara bölmeyi seçebilirsiniz.`
    },
    {
        t:"Rezervasyon",
        q:"Rezervasyonumu iptal edebilir miyim?",
        a:`Evet, herhangi bir sürücü siparişinizle eşleştirilmeden önce ve sürücünüz ilk adrese yola çıkmadan önce rezervasyonunuzu iptal edebilirsiniz.
        Sürücünüz ilk adrese vardıktan sonraki iptallerde sipariş tutarının %50 sini iade alabilirsiniz. 
        Taşımacım Müşteri Hizmetleri Yardım Hattı her gün sabah 9'dan akşam 6'ya kadar kullanılabilir fakat bize uygulama üzerinden 24 saat ulaşabilirsiniz.`
    },
    {
        q:"Acil bir araca ihtiyacım var ama şoför bulamıyorum. Ne yapabilirim?",
        a:`Sürücülerin arzı, yoğun saatlerde siparişlerde bir artış olduğundan çevrimiçi tüketicilerin ihtiyaçlarını karşılayamayabilir. Rezervasyonunuzun bir sürücüyle eşleşme şansını artırmak için bir "bonus" eklemenizi öneririz. "Bonus" seçeneği, sürücü eşleştirme işleminin ilerlemesini gösteren ekranda mevcuttur.`
    },
    {
        t:"Siparişle İlgili Sorunlar",
        q:"Rezervasyon yapıldıktan sonra sürücünün/yolcunun teslim alma yerine varması ne kadar sürer?",
        a:"Rezervasyonunuz bir sürücüyle eşleştirildikten sonra, sürücü rezervasyon bilgilerinizi ve varış saatinizi sizinle onaylamak için mümkün olan en kısa sürede sizinle iletişime geçecektir. Sürücüye, araba kullanıyor olabileceğinden, sizinle iletişime geçmesi için biraz zaman tanıyın. Sürücü eşleştirildikten sonraki 10 ~ 15 dakika içinde sizinle iletişime geçmezse, varış saatini, rezervasyonunuzun ayrıntılarını ve ek ücretleri / ücretleri (varsa) onaylamak için sürücüyle bir arama başlatabilirsiniz."
    },
    {
        q:"Şoförüm son derece geç kaldı veya uygun bir bildirimde bulunmadan rezervasyonum için gelmedi. Ne yapmalıyım?",
        a: `Planlanmış rezervasyonunuzdan 30 dakika önce sürücünüzü uygulama üzerinden arayıp kontrol etmeniz önerilir. Bir süre sonra sürücünüzle iletişime geçemezseniz, lütfen başka bir sürücüyle eşleştirilmek üzere siparişinizi iptal edin ve yeni bir sipariş oluşturun. 
        Kaçırılan sipariş için lütfen +90 850 270 07 23 numaralı telefonu arayın veya bir rapor hazırlamak ve sorununuzu araştırmamıza izin vermek için destek@taşımacım.com yazın.`
    },
    {
        q:"Gelen aracın plakası, sürücü eşleştirildiğinde verilen detaylarla uyuşmuyorsa ne yapmam gerekir?",
        a:`Durumu bildirmek için lütfen hemen +90 850 270 07 23 numaralı müşteri hizmetleri hattımızı arayın.`
    },
    {
        q:"Nakit ödeme dışında, sürücüye başka nasıl ödeme yapabilirim?",
        a:"Nakit veya kredi kartı ile ödeme yapmayı tercih edebilirsiniz."
    },
    {
        q:"Rezervasyonum onaylandıktan sonra değişiklik yapmak istersem ne yapmalıyım?",
        a:`Rezervasyonunuzda yapmak istediğiniz yukarıdaki değişikliklerden herhangi biri için lütfen sizinle eşleşen sürücüyle iletişime geçin. Eğer değişiklik sürücünüze uymuyorsa lütfen siparişinizi iptal edin ve yeni bir sipariş oluşturun. 
        Yukarıda listelenmeyen diğer değişiklikler için lütfen yardım almak üzere uygulama üzerinden müşteri hizmetleri yardım sohbet bölümünden bize ulaşın.`
    },
    {
        t:"Kayıp & Bulunan",
        q:`Yolculuğum tamamlandıktan sonra sürücülerin aracında geride bir şey bıraktıysam ne yapabilirim?`,
        a:`Siparişiniz tamamlandıktan 30 dakika içerisinde, lütfen sizinle eşleşen sürücüyle uygulama üzerinden iletişime geçin. Sürücüyle iletişime geçemiyorsanız, yardım almak için uygulama üzerinden müşteri hizmetleri yardım sohbet bölümünden bize ulaşın.`
    },
    {
        t:"Fatura & Fiş",
        q:"Seyahatim tamamlandıktan sonra rezervasyonum hakkında ki bilgileri görebilir miyim?",
        a:"Tüm sipariş bilgilerinizi geçmiş siparişlerim bölümüne tıklayarak ulaşabilirsiniz."
    },
    {
        q:"Sipariş detaylarımın bana e-postayla gönderilmesini nasıl sağlayabilirim?",
        a:"Sipariş detaylarının size e-posta yoluyla gönderileceğinden emin olmak için profilinizi bir e-posta adresiyle güncellemeniz gerekir."
    },
    
    {
        q: "Taşımacım'dan fatura talep edebilir miyim?",
        a: `Taşımacım, taşıma şirketlerini ve eşya taşıtmak isteyen müşterileri bir araya getirerek, aracı hizmet sağlayıcı sıfatında sanal bir teknoloji platformudur. Aldığınız hizmetin direk sağlayıcısı olmadığı için, istese bile KDV faturası kesemez.
        Taşımacım’ın gelir kaynağı taşıma şirketleri ve eşyalarını taşıtmak isteyen müşteriler arasındaki sipariş bedelinden elde ettiği komisyon tutarıdır. Bu tutarı müşteriden değil, taşıma şirketlerinden tahsil eder ve komisyon tutarı için taşıma şirketlerine fatura keser.
        Sipariş detaylarınızı girerken fatura istediğinizi taşıma şirketlerine belirtirseniz, talebinizi yerine getirebilirler.`
    },
    {
        t:"Ödeme",
        q:"Taşımacım hangi ödeme yöntemlerini destekliyor?",
        a:"Nakit veya kredi kartı ile ödeme yapmayı tercih edebilirsiniz."
    },
    {
        q:"Kredi kartıyla ödeme hakkında daha fazla bilgi edinin",
        a:`Taşımacım, sipariş verildikten sonra kredi kartınızdan sipariş tutarını tahsil eder. Bu tutar sipariş tamamlandıktan sonra sürücünüzün Taşımacım cüzdanına aktarılır.
        Ekstralar olması halinde (Eşyaların asansörle taşınamaması, vb.) müşteriler nakit ödeme yöntemini kullanarak ödemesini gerçekleştirebilir
        Sipariş sürücü yola çıkmadan iptal edilirse, işlem Taşımacım tarafından iptal edilir, tutarın hesabınıza geri aktarım süresi bankanıza bağlı olarak değişkenlik gösterebilir.`
    }

]

export default class FAQ extends React.Component {

    constructor() {
        super();
    }

    render() {
        return <div><NavBar /><div style={{display:"flex", paddingTop:150,flexDirection:"column",alignItems:"center"}}>

            <div style={{paddingBottom:200, alignItems:"center",textAlign:"center",display:"flex",flexDirection:"column"}}>
                <div style={{width:"90%", maxWidth:1080}}>
                <p style={{fontSize:32, lineHeight:"40px", fontWeight:"500",marginBottom:50}}>Sıkça Sorulan Sorular</p>


                {questions.map((question, i) => <>
                
                {question.t && <p style={{marginTop:50, marginBottom:15, fontSize:25, fontWeight:"600",textAlign:"left"}}>{question.t}</p>}
                <div key={i} style={{backgroundColor:(question.expanded)?Colors.Blue:"white",transition:"all .2s", paddingTop:20,paddingBottom:20,paddingLeft:40, width:"100%",border:(question.expanded)?"none":"1.5px solid #E3E7EC", borderRadius:4, marginBottom:20}}>
        <div style={{cursor:"pointer", display:"flex", flexDirection:"row", justifyContent:"space-between", paddingRight:40}}  onClick={() => {
            if(question.expanded == undefined) question.expanded = false;
            question.expanded = !question.expanded;

            this.forceUpdate();
        }}>
            <p style={{fontSize:20,lineHeight:"32px",color:(question.expanded)?"white":"#000",textAlign:"left"}}>{question.q}</p>
            <div className={(question.expanded)?'indicator active':'indicator'}></div>
            
            </div>
        <div style={{maxHeight:(question.expanded)?((question.a.length<=200)?"100px":"500px"):"0px"}} className={(question.expanded)?'expanded expandeeed':'expanded'} >
            {question.a.split("\n").map((x, i) => <p key={i} style={{paddingRight:40,color:"white",fontSize:16,marginTop:(i == 0)?0:10,lineHeight:"24px",textAlign:"left"}}>{x}</p>)}
            {/* <p  style={{paddingRight:40,color:"white",fontSize:16,lineHeight:"24px",textAlign:"left"}}>{question.a}</p> */}
        </div>
    </div></>)}
                {/* <p style={{fontWeight:"600", marginTop:20,fontSize:16}}>Merhaba! Nasıl yardımcı olabiliriz?</p>
                <p style={{marginTop:5}}>Email: destek@tasimacim.com <br />
Telefon: +90 850 270 07 23<br /></p>
<p style={{fontWeight:"600", marginTop:20,fontSize:16}}>İşletmeler için</p>
                <p style={{marginTop:5}}>business@tasimacim.com<br />
                Telefon: +90 850 270 07 23</p>
                
                <p style={{marginTop:20}}>Kavacık Mah. Fatih Sultan Mehmet Cad. Tonoğlu No: 3 / 4 Beykoz / İstanbul</p>

                   <p style={{marginTop:5}}>Taşımacım Nakliyat Lojistik Aracılık Hizmetleri Limited Şirketi</p> */}
            </div>
            </div>
            <Footer />
        </div></div>
    }
}


